import { env } from "../config"
import store from "@/store"

let openAppEnv = env === "pro" || !env ? "" : env

const openApp = ({ address, title = document.title || "南方报业小记者" }) => {
  const options = {
    id: 12,
    shareType: "share",
    title,
    isActivity: true,
    address,
    needClipboard: true,
    activityInfo: {
      subActivityId: window.categoryId || "",
      activityId: store.state.activityInfo.activityId || "",
      activityType: "2"
    }
  }
  window.OpenApp(options, openAppEnv)
}

export default openApp
